<header class="page-header">
  <div class="page-header__titles">
    @if (eyebrow) {
    <p class="page-header__eyebrow">{{ eyebrow }}</p>
    }
    <h1 class="page-header__title">{{ title }}</h1>
    @if (subtitle) {
    <p class="page-header__subtitle">{{ subtitle }}</p>
    }
  </div>
  <div class="page-header__actions">
    <ng-content></ng-content>
  </div>
</header>
